// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
};

(function() {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

  SearchInput.prototype.afterBindEvents = function() {
    // Fix cannot close search suggestion when clicking overlay 
    document.addEventListener('click', function(e) {
      if(this.searchAutoComplete && this.searchAutoComplete.isOpen && e && e.target) {
        var $clickedElement = jQ(e.target);
        var isClickSuggestion = $clickedElement.closest('.' + Class.searchSuggestionWrapper).length > 0;
        if (isClickSuggestion) {
          this.searchAutoComplete.$element.hide();
          this.searchAutoComplete.searchInput.onCloseAutocomplete();
          this.searchAutoComplete.isOpen = false;
        }
      }
    }.bind(this), true);
  }

  InstantSearchApi.beforeCall = function(eventType, eventInfo) {
    /* Change the filter params before calling api */
    // Globals.instantSearchQueryParams.tag = [`_exclusive:${window.customer.group_name}`, '_standard'];
    Globals.instantSearchQueryParams.tag_mode = '2';

    // Boost Start #228243
    var customerGroup = 'guest';
    if(window.customer.group_name){
      customerGroup = window.customer.group_name;
    }
    Globals.instantSearchQueryParams.h_options = 'isnot_'+customerGroup;
    // Boost End #228243
    
    // Boost 199860
    // var groub_name_list = [];
    // var allListHiddenOnly = [];
    // var allExclusive = [];

    // if(window.customer_group_tags) {
    //   for (var customer_group_tag of window.customer_group_tags) {
    //     if (!groub_name_list.includes(customer_group_tag.group_name)) { 
    //       groub_name_list.push(customer_group_tag.group_name);
    //     }
    //     if(!allListHiddenOnly.includes('hide_' + customer_group_tag.group_name)) {
    //       allListHiddenOnly.push('hide_' + customer_group_tag.group_name);
    //     }
    //     if(!allExclusive.includes('exclusive:' + customer_group_tag.group_name)) {
    //       allExclusive.push('exclusive:' + customer_group_tag.group_name)
    //     }
    //   }
    // }
    // if(window.customer && window.customer.group_name) {
    //     var newListHidden = groub_name_list.filter(e => e !== window.customer.group_name);
    //     // newListHidden = newListHidden.map(e => 'exclusive_' + e);
    //     var hiddenOnly = 'hide_' + window.customer.group_name;
    //     newListHidden.push(hiddenOnly);
    //     Globals.instantSearchQueryParams.h_options = newListHidden;
    // } else {
    //     var hiddenList = groub_name_list.concat(allListHiddenOnly);
    //     Globals.instantSearchQueryParams.h_options = groub_name_list;
    // }
    // End 199860
    /* No need to return anything */
  }
})();